var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStatusField = function SvgStatusField(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 3C9.53 3 9.25 3.28 9.25 3.625V6H6.625C6.28 6 6 6.28 6 6.625V9.25H3.625C3.28 9.25 3 9.53 3 9.875V12.375C3 12.72 3.28 13 3.625 13H11.375C11.5884 13 11.7997 12.958 11.9969 12.8763C12.194 12.7946 12.3732 12.6749 12.524 12.524C12.6749 12.3732 12.7946 12.194 12.8763 11.9969C12.958 11.7997 13 11.5884 13 11.375V3.625C13 3.28 12.72 3 12.375 3H9.875Z",
    fill: "#1764C0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStatusField);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "status-field.67d2249dd1744f754592290a673d2146.svg";